import type { PeriodType } from "../../../../../../../../api/types/svTypes.ts";

export const availablePeriodTypes = [
  { value: "LastMonth", text: "Last Month" },
  { value: "LastQuarter", text: "Last Quarter" },
  { value: "LastYear", text: "Last Year" },
];

export const getPeriodTypeFormattedValue = (periodType: PeriodType) => {
  return availablePeriodTypes.find((item) => item.value === periodType)?.text;
};
